import { useState } from "react";
import { Card } from "@/shared/ui/Card";
import { ErrorBanner } from "@/shared/ui/ErrorBanner";
import { prettifyApiError } from "@/shared/api";
import { importBizzottoCatalog } from "../api";

// Import del catalogo Bizzotto dal Google Sheet di Davide (R4, 2026-07-03).
// Il default dell'URL vive server-side: qui solo il bottone + feedback.
// Replace-all lato backend → dopo l'import notifichiamo il parent così la
// tabella entries si ricarica (onImported).

export function BizzottoImportCard({ onImported }: { onImported: () => void }) {
  const [importing, setImporting] = useState(false);
  const [imported, setImported] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function runImport() {
    setImporting(true);
    setError(null);
    setImported(null);
    try {
      const result = await importBizzottoCatalog();
      setImported(result.imported);
      onImported();
    } catch (err) {
      setError(prettifyApiError(err));
    } finally {
      setImporting(false);
    }
  }

  return (
    <Card className="mb-4 p-5">
      <h2 className="font-display text-[16px] font-bold text-ink mb-2">
        Importa catalogo da Google Sheet
      </h2>
      <p className="text-[12.5px] text-ink-2 leading-relaxed mb-3">
        Legge il Google Sheet condiviso (URL configurato lato server) e sostituisce integralmente il
        catalogo Bizzotto: nome, categoria, prezzo, EAN Bizzotto/BSCOM e dimensioni prodotto.
      </p>
      <button
        type="button"
        onClick={() => void runImport()}
        disabled={importing}
        className="rounded-full border border-ink bg-ink px-3 py-1.5 text-[12.5px] font-medium text-on-ink disabled:opacity-50"
      >
        {importing ? "Importo..." : "Importa catalogo da Google Sheet"}
      </button>
      {imported !== null && (
        <div className="mt-3 rounded-full border border-green/20 bg-green-soft px-3 py-2 text-[12.5px] text-ink">
          Import completato: {imported} righe importate.
        </div>
      )}
      <ErrorBanner message={error} className="mt-3" />
    </Card>
  );
}
